import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateEmploymentComponent } from './update-employment.component';
import { UpdateEmploymentRoutingModule } from './update-employment-routing.module';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { TabViewModule } from 'primeng/tabview';
import {TabMenuModule} from 'primeng/tabmenu';
@NgModule({
  imports: [
    CommonModule,
    UpdateEmploymentRoutingModule,
    RadioButtonModule,
    FormsModule,
    SharedModule,
    TabViewModule,
    TabMenuModule,
  ],
  declarations: [
    UpdateEmploymentComponent
  ],
  exports: [
    UpdateEmploymentComponent
  ],
})
export class UpdateEmploymentModule { }
